import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';

const faqData = [
  {
    question: "Quelles sont vos plages horaire?",
    answer: "Nous allons à domicile pour des soins de santé les mercredis en journée et les dimanches PM. Pour les pensions, nous discutons avec vous de vos besoins."
  },
  {
    question: "Êtes vous assuré?",
    answer: "Oui nous avons des assurances professionnelles et civiles."
  },
  {
    question: "Faites vous les rendez-vous à deux?",
    answer: "Il n’y a que les pensions où nous sommes seules. Autrement les rendez-vous se font toujours à deux."
  },
  {
    question: "Quels matériels dois-je avoir pour vous accueillir?",
    answer: "Aucun matériel n’est nécessaire. Nous nous occupons de tout apporter."
  },
  {
    question: "Quels sont nos modes de paiement acceptés?",
    answer: "Virement bancaire et comptant (argent exact)."
  },
  {
    question: "Quelles régions nous desservons ?",
    answer: "Rive nord de Montréal et les basses Laurentides."
  },
  {
    question: "Quelle est notre expérience professionnelle ?",
    answer: "Annie a obtenu son diplôme en 2009 et Fannie en 2006, toutes deux dans le domaine vétérinaire."
  },
  {
    question: "Quels actes nous avons le droit de pratiquer ?",
    answer: (
      <>
        <p className="mb-2">Il serait moins long de citer les actes interdits. Les actes uniquement vétérinaires (que nous ne faisons PAS) sont :</p>
        <ul className="list-disc list-inside pl-2 space-y-1 text-stone-600">
          <li>Examen physique et vaccination</li>
          <li>Poser un diagnostic de problème de santé</li>
          <li>Émettre une prescription</li>
          <li>Pratiquer une intervention chirurgicale</li>
        </ul>
        <p className="mt-2 font-medium text-teal-600">Pour tout le reste (soins, traitements, hygiène), nous sommes là pour vous !</p>
      </>
    )
  }
];

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <motion.div 
      initial={false}
      className={`border rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-teal-200 bg-teal-50/30' : 'border-stone-100 bg-white'}`}
    >
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
      >
        <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-teal-800' : 'text-stone-700'}`}>
          {question}
        </span>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          className={`flex-shrink-0 ml-4 ${isOpen ? 'text-teal-600' : 'text-stone-400'}`}
        >
          <ChevronDown size={20} />
        </motion.div>
      </button>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <div className="px-6 pb-6 text-stone-600 leading-relaxed border-t border-teal-100/50 pt-4">
              {answer}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Decorative background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full pointer-events-none">
        <div className="absolute top-40 -left-20 w-72 h-72 bg-teal-50 rounded-full blur-[100px] opacity-60" />
        <div className="absolute bottom-20 -right-20 w-80 h-80 bg-orange-50 rounded-full blur-[100px] opacity-60" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-flex items-center justify-center w-12 h-12 bg-teal-100 text-teal-600 rounded-xl mb-4">
            <HelpCircle size={24} />
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-stone-900 mb-4">Questions Fréquentes</h2>
          <p className="text-stone-500 max-w-2xl mx-auto">
            Vous avez des questions ? Nous avons les réponses. Si vous ne trouvez pas ce que vous cherchez, n'hésitez pas à nous contacter.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqData.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={openIndex === index}
              onClick={() => toggleIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
